import React, { Component } from 'react'
import { connect } from 'react-redux'
import Loader from 'react-loader-spinner';
import { updateTag, deleteTag } from '../../../../store/actions/projectActions';

class UpdateTagModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            oldTagName: this.props.tagMap.name,
            tagName: this.props.tagMap.name,
            tagid: this.props.tagMap.tagid,
        }
    }

    /// README: GETTING USER INPUT
    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    /// README: UPDATING A TAG ACTION
    handleSubmit = (e) => {
        e.preventDefault();
    }

    handleTagDelete = () => {
        const { proid } = this.props.snagDetail;
        const { tagid, tagName } = this.state;

        this.props.deleteTag(proid, tagid, tagName);
    }

    handleUpdateTag = () => {
        const { snagDetail, commons } = this.props;
        const { proid, allTagsMap } = snagDetail;
        const { oldTagName, tagName, tagid } = this.state;

        if (tagName !== oldTagName) {
            var tagMap = {
                tagName, tagid,
            }
            if ('allTagsMap' in snagDetail ? Object.values(allTagsMap).some((eachTag) => eachTag.name === tagName) : false) {
                alert(`${commons.utagCategory} name exists`)
            }
            else {
                this.props.updateTag(proid, tagMap);
            }
        } else {
            alert(`Please enter a new ${commons.utagCategory} name to update!`);
        }
    }

    /// README: RENDER THE UI
    render() {
        const { tagName } = this.state;
        const { modalTitleStyle, formLabelStyle, modalWidth, utagCategory, tagCategory } = this.props;

        //////////////////////////////////////////////////////////////////////////////////////////////
        /// README: seeing the state of form (do styling adjustments but be cautious with state)
        ///
        const { isTagCreating } = this.props.project;
        const textStyle = {
            color: this.props.themeColors.darkThemeColor,
        }
        const relevantSubmitComponent = isTagCreating ?
            (<React.Fragment>
                <Loader
                    type="TailSpin"
                    color={this.props.themeColors.themeColor}
                    height={20}
                    width={20}
                />
                <br></br>
                <p style={textStyle}>Processing...</p>
                <br></br>
            </React.Fragment>)
            :
            (<React.Fragment>
                <button className="btn btn-dark btn-sm" onClick={() => { this.handleUpdateTag() }}>Update this {tagCategory}</button>
                <button className="btn btn-link btn-sm ml-2" onClick={() => { this.handleTagDelete() }}>Delete</button>
            </React.Fragment>);

        //////////////////////////////////////////////////////////////////////////////////////////////
        /// README: return the form
        ///
        return (
            <div className="dynamicModalContainer">
                <div className="dynamicModalSm">
                    <br></br>
                    <form onSubmit={this.handleSubmit}>
                        <div className="form-group text-left">
                            <label htmlFor="inputText" style={modalTitleStyle}>{utagCategory} name</label>
                            <input type="text" className="form-control" id="tagName" onChange={this.handleChange} required value={tagName} />
                        </div>
                    </form>
                    <br />
                    {relevantSubmitComponent}
                    <br />
                    <br />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        alu: state.alu,
        formLabelStyle: state.appControl.formLabelStyle,
        project: state.project,
        modalWidth: state.appControl.modalWidth,
        modalTitleStyle: state.appControl.modalTitleStyle,
        commons: state.commons,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        deleteTag: (proid, tagid, tagName) => dispatch(deleteTag(proid, tagid, tagName)),
        updateTag: (proid, tagMap) => dispatch(updateTag(proid, tagMap)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateTagModal)